export default "__VITE_ASSET__37WN5lDn__"